/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { headerBreak } from '@/components/content/Header/styles/break';
import { SxProps, Theme } from '@mui/material';

export const headerSearchSX =
	({ isMobile, expanded }: { isMobile?: boolean; expanded?: boolean }): SxProps<Theme> =>
	(theme) => ({
		transition:
			expanded && !isMobile
				? 'width 0.6s ease-in-out, max-width 0.6s ease-in-out, right 0.6s ease-in-out, top 0.6s ease-in-out'
				: 'none',
		width: isMobile ? '90%' : expanded ? '100%' : '180px',
		maxWidth: isMobile ? '90%' : expanded ? '100%' : '180px',
		marginRight: '0px',
		paddingBottom: expanded ? theme.dimensions.dpSpacing.spacing3 : 'inherit',
		paddingTop: expanded ? theme.dimensions.dpSpacing.spacing3 : 'inherit',
		position: expanded ? 'relative' : 'relative',
		right: expanded ? 0 : 'inherit',
		top: expanded ? 0 : 'inherit',
		marginLeft: isMobile ? '0px !important' : expanded ? '0px !important' : 'inherit',
		marginTop: isMobile ? theme.dimensions.dpSpacing.spacing3 : '0px',
		display: headerBreak({ mobile: 'flex', desktop: 'inherit' }),
		...(isMobile
			? { mb: theme.dimensions.dpSpacing.spacing7, ml: 0, mr: theme.dimensions.dpSpacing.spacing7 }
			: {}),

		'.MuiOutlinedInput-notchedOutline': {
			borderColor: `${theme.palette.extraColors.lightGray} !important`,
			'&:hover': {
				borderColor: 'transparent !important',
			},
		},

		'.MuiInputBase-sizeSmall': {
			borderRadius: theme.dimensions.dpSpacing.spacing5,
			backgroundColor: theme.palette.extraColors.lightGray,
			paddingLeft: '15px!important',
			height: isMobile ? '50px' : 'inherit',
		},

		'.MuiOutlinedInput-input': {
			'&::-webkit-input-placeholder': {
				opacity: 0.5,
			},
		},
	});

export const headerSearchMobileButtonIconSX: SxProps<Theme> = (theme) => ({
	color: theme.palette.text.primary,
	fontSize: theme.typography.dpXl,
});

export const headerSearchTextFieldSX: SxProps<Theme> = (theme) => ({
	fontSize: {
		xs: theme.typography.dpBody?.fontSize,
		sm: theme.typography.dpSmall?.fontSize,
	},
});

export const headerSearchTextFieldInputAdornmentStartSX: SxProps<Theme> = { marginRight: '0px' };

export const headerSearchTextFieldInputAdornmentStartButtonSX: SxProps<Theme> = (theme) => ({
	color: theme.palette.text.primary,
});

export const headerSearchTextFieldInputAdornmentEndButtonSX: SxProps<Theme> = (theme) => ({
	...theme.typography.dpSmall,
	padding: '0px',
	color: theme.palette.extraColors.darkGray,
	height: '30px',
	'&:hover': {
		backgroundColor: 'transparent',
	},
});
